export default [
  { text: "product.recipient_type.COMPANY", value: "COMPANY" },
  { text: "product.recipient_type.GENERAL", value: "GENERAL" },
];
